module.exports = __webpack_public_path__ + "static/media/port2.2718f577.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/EditorStudies/port2.png
// module id = 167
// module chunks = 0